import { App } from 'vue'
import installHttp, { useHttp } from './http'
import installArco from './arco-design'
import installIconPark from './icon-park'
export { ssePost } from './http/sse'

const usePlugins = (app: App): void => {
  // 注册http请求
  installHttp(app)
  installArco(app)
  installIconPark(app)
}

export {
  usePlugins,
  useHttp
}
